module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 259
// module chunks = 1